/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const $card = $(this).parents('[data-line-item]');

      // Custom-options parents carry their add-on lines with them
      const addonItemKeys = $card.attr('data-addon-item-keys');
      if (addonItemKeys) {
        Shopify.theme.jsCart.removeItemWithAddons(addonItemKeys, $card.attr('data-cart-item'));

        return false;
      }

      const lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  removeItemWithAddons: function (addonItemKeys, parentItemKey) {
    const updates = {};
    updates[parentItemKey] = 0;

    addonItemKeys.split(',').filter(Boolean).forEach(function (key) {
      updates[key] = 0;
    });

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      contentType: 'application/json',
      data: JSON.stringify({ updates: updates }),
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsCart.refreshView(cart);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  refreshView: function (cart) {
    // Full item-list refresh: line numbers shift when several lines are
    // removed at once, so the whole list is re-rendered instead of patching
    // individual rows.
    $.ajax({
      dataType: 'html',
      cache: false,
      url: '/cart',
      success: function (html) {
        const updatedCartList = $(html).find('.cart__item-list');
        $('.cart__item-list').replaceWith(updatedCartList);
      }
    });

    Shopify.theme.jsCart.updateView(cart, null);
  },
  updateView: function (cart, lineID) {

    // Match snippets/bold-options-hybrid-cart-item-count.liquid: Bold Options
    // hidden child line items must not count toward the displayed cart total.
    // Custom-option add-on lines (_addon_for) get the same treatment.
    const displayItemCount = cart.items.reduce(function (count, item) {
      const properties = item.properties || {};
      const isBoldChildItem = properties._boldBuilderId && properties._boldVariantIds == null;
      const isAddonItem = Boolean(properties._addon_for);
      return isBoldChildItem || isAddonItem ? count : count + item.quantity;
    }, 0);

    if (displayItemCount > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(displayItemCount);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;